import React, { useEffect, useState } from "react";
import KartuUjian from "./ubmfile/kartuujian";
import "./ubmfile/kartupeserta.css";

import { PDFDownloadLink } from "@react-pdf/renderer";
import KartuUjianPDF from "./ubmfile/KartuUjianPDF";

const DaftarKartuUjian = () => {
  const [dataPeserta, setDataPeserta] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ================= FETCH DATA ================= */
  const fetchKelas = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/admin/refrensi/getKartuUjian`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      if (!response.ok) {
        throw new Error("Gagal mengambil data kartu ujian");
      }

      const result = await response.json();
      console.log(result.data)
      setDataPeserta(result.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchKelas();
  }, []);

  /* ================= RENDER ================= */
  return (
    <>
      {/* ===== PREVIEW HTML ===== */}
      {/* <div className="row-print">
        {loading && <p>Memuat data...</p>}

        {!loading &&
          dataPeserta.map((item, i) => (
            <div className="col-print" key={i}>
              <KartuUjian data={item} />
            </div>
          ))}
      </div> */}

      {/* ===== ACTION ===== */}
      <div style={{ marginTop: 20 }}>
        <PDFDownloadLink
          document={<KartuUjianPDF data={dataPeserta} />}
          fileName="kartu-ujian.pdf"
        >
          {({ loading }) =>
            loading ? "Menyiapkan PDF..." : "Download PDF"
          }
        </PDFDownloadLink>
      </div>
    </>
  );
};

export default DaftarKartuUjian;